import React, { FC } from 'react';
import { compose } from 'react-recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { useIntercom } from 'react-use-intercom';
import { ForgotPassword } from '@dev/ee-modules';
import { ActivationPayload, ProductCode } from '@dev/ee-api/ee-api-models';

import { ResendActivationEmail } from '@api/store/auth/actions';
import { ResetPassword } from '@api/store/account/actions';
import { ApplicationState as State } from '@api/store';
import { useMobile } from '@api/services/hooks/useMobile';

import { ForgotPasswordProps } from './ForgotPasswordInterface';
import { isIntercomEnabled } from '@api/services/Security';

type DispatchActions = {
    ResetPassword(email: string): void;
    Push(url: string): void;
    ResendActivationEmail(payload: ActivationPayload): void;
};

type Props = ForgotPasswordProps & DispatchActions;

const dispatchActions = { ResetPassword, Push, ResendActivationEmail };

const mapState = (state: State, ownProps: ForgotPasswordProps): ForgotPasswordProps => {
    return {
        ...ownProps,
        account: state.account,
    };
};

const ForgotPasswordScreen: FC<Props> = ({ ResetPassword, Push, ResendActivationEmail }: Props): JSX.Element => {
    const isMobile = useMobile();
    const { show } = useIntercom() || {};

    const launchIntercom = () => {
        isIntercomEnabled() && show();
    };

    return (
        <ForgotPassword
            productCode={ProductCode.EmailApi}
            ResetPassword={ResetPassword}
            ResendActivationEmail={ResendActivationEmail}
            Push={Push}
            launchIntercom={launchIntercom}
            isMobile={isMobile}
        />
    );
};

export default compose(withTranslation(), connect<ForgotPasswordProps, DispatchActions>(mapState, dispatchActions))(ForgotPasswordScreen);
